import servicesUtils from "../../../utils/servicesUtils";
import { useMutation } from "react-query";
function useMutateSingleWorkspace(workspaceId) {
  return useMutation(function (params) {
    return servicesUtils.postService("/workspaces/".concat(workspaceId, "/"), params);
  });
}
export default useMutateSingleWorkspace;